export default "__VITE_ASSET__DjkN70NW__"